
import VideoPlayer from '../ui/VideoPlayer.vue'

export default {
  components: { VideoPlayer },
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
